export default __webpack_public_path__ + "static/media/market001.81b4196c.png";